import FetchFactory from '../factory'

interface ISubscribe {
  body: {
    email: string
    'g-recaptcha-response'?: string
    source?: string
  }
}
interface IVerify {
  query: {
    email: string
    expires: string
    hash: string
    signature: string
  }
}

class MarketingModule extends FetchFactory<any> {
  async subscribe(payload: ISubscribe) {
    const { body } = payload
    return await useAsyncData(() => {
      return super.call('/api/marketing/subscribers', {
        method: 'POST',
        body
      })
    })
  }

  async verify(payload: IVerify) {
    const { query } = payload
    return await useAsyncData(() => {
      return super.call('/api/marketing/subscribers/verify/job_seeker', {
        method: 'GET',
        query
      })
    })
  }
}

export default MarketingModule
